"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PaginationButtonMixin = require("../../mixins/components/PaginationButtonMixin");
var _Button = require("../Button/Button");
var _excluded = ["disabled", "pressed"];
/**
 * A button used by the `Pagination` component.
 *
 * @extends Button
 * @since 7.42.0
 */
var PaginationButton = /*#__PURE__*/(0, _styledComponents.default)(function (_ref) {
  var disabled = _ref.disabled,
    pressed = _ref.pressed,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Button.Button, (0, _extends2.default)({
    borderless: true,
    "aria-pressed": pressed ? true : undefined,
    disabled: disabled,
    tabIndex: disabled ? -1 : undefined
  }, rest));
}).withConfig({
  displayName: "PaginationButton",
  componentId: "c11n-8-107-0__sc-1i6hxyy-0"
})(["", ""], _PaginationButtonMixin.PaginationButtonMixin);
exports.PaginationButton = PaginationButton;
PaginationButton.displayName = 'PaginationButton';
PaginationButton.propTypes = {
  /**
   * @ignore
   */
  buttonType: _propTypes.default.string,
  /**
   * By default, this is rendered as an HTML button. You can change it to an anchor for example
   * by changing this to "a".
   */
  forwardedAs: _propTypes.default.string,
  /**
   * The label for the page button, `Page x`, `Page x, current page`,
   * `Next page`, or `Previous page`
   */
  title: _propTypes.default.string.isRequired,
  /**
   * Sets the [aria-pressed](https://www.w3.org/TR/wai-aria-1.1/#aria-pressed) state.
   */
  pressed: _propTypes.default.bool
};
PaginationButton.defaultProps = {
  buttonType: 'tertiary',
  forwardedAs: undefined,
  pressed: false
};

/** @component */